export default __webpack_public_path__ + "static/media/convertable.74356cf9.svg";